export default "__VITE_ASSET__BlJgFDI0__"